import {
  faCheckCircle,
  faPauseCircle,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  error,
  success,
} from "../../../../components/alertMessagesHandler/alert";
import CButton from "../../../../components/buttons/Button";
import CDataTable from "../../../../components/datatable/datatable";
import CTextAreaField from "../../../../components/inputBoxes/textArea-input";
import { LoadingContext } from "../../../../context/loadingContext";
import {
  ApproveOrderHook,
  downloadFileHooks,
  HoldOrderHook,
  MyPortalHooks,
  RejectOrderHook,
} from "../hooks/newOrderHooks";
import NewOrdersMobile from "./newOrderMobile";

const NewOrders = () => {
  const { setLoading } = useContext(LoadingContext);
  const [ordersList, setOrdersList] = useState([]);
  const [onHoldOrderId, setonHoldOrderId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [holdComment, setHoldComment] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    (async () => {
      window.addEventListener("resize", () => {
        setWindowWidth(window.innerWidth);
      });

      // List of new orders in created status using MyPortalHooks

      const list = await MyPortalHooks();
      setOrdersList(list.data);
      setLoading(false);
      if (window.innerWidth <= 992)
        document.getElementById("sidebarToggle").click();
    })();
  }, []);

  // Approve new order using ApproveOrderHook

  const ApproveOrder = async (order_id) => {
    setLoading(true);
    const result = await ApproveOrderHook({ order_id: order_id });
    if (result.status === 200) {
      const list = await MyPortalHooks();
      setOrdersList(list.data);
      setLoading(false);
    }
  };

  // Reject new order using RejectOrderHook

  const RejectOrder = async (order_id, mkt_email) => {
    setLoading(true);
    const result = await RejectOrderHook({ order_id: order_id, mkt_email: mkt_email });
    if (result.status === 200) {
      const list = await MyPortalHooks();
      setOrdersList(list.data);
      setLoading(false);
      navigate("/dashboard/rejected/" + order_id);
    }
  };

  // Hold new order using HoldOrderHook

  const HoldOrder = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await HoldOrderHook(onHoldOrderId, holdComment);
    if (result.status === 200) {
      success("Order On Hold");
      const list = await MyPortalHooks();
      setOrdersList(list.data);
      setLoading(false);
    } else error(result.message);
    setLoading(false);
    setShowModal(false);
  };

  // Download file by s3bucket using downloadFileHooks

  const downloadFile = async (order_id) => {
    setLoading(true);
    const result = await downloadFileHooks(order_id);
    setLoading(false);
    const downloadBtn = document.getElementById("download-btn");
    downloadBtn.href = result;
    downloadBtn.click();
  };

  return (
    <>
      {/* <CDataTable
        column={[
          {
            name: "S.No",
            selector: (row, index) => index + 1,
            center: true,
          },
          {
            name: "Date",
            selector: (row) => row.order_date.split("T")[0],
            sortable: true,
            center: true,
          },
          {
            name: "Order#",
            selector: (row) => row.doi_id,
            center: true,
          },
          {
            name: "Portal name",
            selector: (row) => row.data_portal_info.portal_name,
            center: true,
          },
          {
            name: "Portal url",
            selector: (row) => row.data_portal_info.portal_url,
            center: true,
          },
          {
            name: "Title of the article",
            selector: (row) => row.title,
            center: true,
            width: "180px",
          },
          {
            name: "Price",
            selector: (row) =>
              "$ " + row.data_portal_info.data_pub_stats[0]["publishing_cost"],
            center: true,
          },
          {
            name: "Approve/Reject",
            selector: (row) => (
              <>
                <div className="row">
                  <div className="col-6">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="text-success fa-2x"
                      onClick={() => ApproveOrder(row.doi_id)}
                    />
                  </div>
                  <div className="col-6">
                    <FontAwesomeIcon
                      icon={faXmarkCircle}
                      className="text-danger fa-2x"
                      onClick={() => RejectOrder(row.doi_id)}
                    />
                  </div>
                </div>
              </>
            ),
            center: true,
          },
        ]}
        data={ordersList.filter((data) => data.file === 0)}
        isHover={true}
        isPagination={true}
        isResponsive={true}
        tableTitle={"New Written Orders"}
        customClassLabel={"fw-bold text-dark mb-3"}
        customClassDiv={"mb-4 mt-5 text-center"}
        fixedHeader={true}
        persistTableHead={true}
      /> */}
      {windowWidth >= 922 ? (
        <>
          <h4 className="text-dark text-center fw-bold mt-4">New Orders</h4>
          <CDataTable
            column={[
              {
                name: "S.No",
                selector: (row, index) => index + 1,
                center: true,
                width: "80px",
              },
              {
                name: "Date",
                selector: (row) => row.order_date.split("T")[0],
                sortable: true,
                center: true,
                width: "120px",
              },
              {
                name: "Order#",
                selector: (row) => row.doi_id,
                center: true,
                width: "100px",
              },
              {
                name: "Portal name",
                selector: (row) => row.data_portal_info.portal_name,
                center: true,
                wrap: true,
              },
              {
                name: "Portal url",
                selector: (row) => row.data_portal_info.portal_url,
                center: true,
                wrap: true,
              },
              {
                name: "Article",
                selector: (row) => (
                  <CButton
                    btnClasses={"btn btn-sm text-decoration-none text-light"}
                    btnCustomStyle={{
                      backgroundColor: "#044389",
                    }}
                    innertext={"View File"}
                    functionName={() => downloadFile(row.doi_id)}
                  />
                ),
                center: true,
              },
              {
                name: "Price",
                selector: (row) =>
                  "$ " +
                  row.data_portal_info.data_pub_stats[0]["publishing_cost"],
                center: true,
                width: "100px",
              },
              {
                name: "Status",
                selector: (row) => row.master_order_status.name,
                center: true,
              },
              {
                name: "Approve/ Reject",
                selector: (row) => (
                  <>
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="text-success fs-5"
                      title="Approve Article"
                      onClick={() => ApproveOrder(row.doi_id)}
                    />
                    &nbsp;
                    <FontAwesomeIcon
                      icon={faXmarkCircle}
                      className="text-danger fs-5"
                      title="Reject Article"
                      onClick={() => RejectOrder(row.doi_id, row.data_mkt_reg.email)}
                    />
                    &nbsp;
                    <FontAwesomeIcon
                      icon={faPauseCircle}
                      className="text-warning fs-5"
                      title="Hold Article and Add Comment"
                      onClick={() => {
                        setonHoldOrderId(row.doi_id);
                        setShowModal(true);
                      }}
                    />
                  </>
                ),
                center: true,
              },
            ]}
            data={ordersList.filter((data) => data.file === 1)}
            isHover={true}
            isPagination={true}
            isResponsive={true}
            customClassLabel={"fw-bold text-dark mb-3"}
            customClassDiv={"mb-4 mt-5 text-center"}
            fixedHeader={true}
            persistTableHead={true}
          />
        </>
      ) : (
        <>
          <NewOrdersMobile
            ApproveOrder={(itemId) => ApproveOrder(itemId)}
            RejectOrder={(id) => RejectOrder(id)}
            setonHoldOrderId={(id) => setonHoldOrderId(id)}
            setShowModal={(status) => setShowModal(status)}
            downloadFile={(id) => downloadFile(id)}
            ordersList={ordersList}
          />
        </>
      )}
      <a href="" className="d-none" id="download-btn"></a>

      <Modal
        show={showModal}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <form onSubmit={HoldOrder}>
          <Modal.Header closeButton>
            <Modal.Title className="text-dark">Hold Order</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CTextAreaField
              labelName={"Add comment to Marketer"}
              name={"description"}
              required={true}
              rowsTextArea={6}
              customClassDiv={"mb-5 text-dark fs-5"}
              customClassInput={"bg-primary-soft w-75"}
              functionName={(name, Description) => setHoldComment(Description)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              onClick={() => {
                setShowModal(false);
              }}
            >
              Close
            </Button>
            <Button type="submit" variant="success">
              Confirm
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default NewOrders;
